import { Box, Center, Spinner, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useGetBidForBuyerQuery } from "../../../autogen/bff-api";
import { MinimumRequirementsTab } from "../bid-detail/MinimumRequirementsTab";

interface Props {
  eventId: string;
  bidId: string;
}

export const MinimumRequirementsFocusBody = ({ eventId, bidId }: Props) => {
  const { t } = useTranslation();
  const { data: detail, isLoading } = useGetBidForBuyerQuery({ eventId, bidId });

  if (isLoading) {
    return (
      <Center py="20">
        <Spinner color="smPrimary" />
      </Center>
    );
  }

  if (!detail) {
    return (
      <Center py="20">
        <Text color="smError">{t("Could not load the bid.")}</Text>
      </Center>
    );
  }

  return (
    <Box maxW="5xl">
      <MinimumRequirementsTab eventId={eventId} bidId={bidId} detail={detail} />
    </Box>
  );
};
